module.exports = __webpack_public_path__ + "img/3_CN_ChineseMicrosite_Homepage_HeroImage.7ca7161e.jpg";